import '../styles.css';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import logo from '../assets/logo.png';
import { useState } from 'react';


const Navbar = ({ menu, setMenu, home, about, skills, works, contact, scroll, lightMode, setLightMode }) => {

    const toggleMode = () => {
        lightMode ? setLightMode(false) : setLightMode(true)
    }

    const goto = (location) => {
        setMenu(false)
        scroll(location)
    }

    const toggleMenu = () => {
        menu ? setMenu(false) : setMenu(true)
    }

    return (
        <div className='navbar'>
            <div className="mobile-navbar">
                <div className={"logo " + ("dark-mode " + (lightMode ? 'logo-dark' : ''))}>
                    <img src={logo} alt="" />
                    <p>BLUEJAG</p>
                </div>
                <div className="navbar-buttons">
                    <div className="menu" onClick={toggleMenu} >
                        {
                            menu ?
                                <CloseOutlinedIcon />
                                :
                                <MenuOutlinedIcon />
                        }
                    </div>
                    <div className={"dark-mode " + (lightMode ? 'logo-dark' : '')} onClick={toggleMode}>
                        {
                            !lightMode ?
                                <WbSunnyOutlinedIcon />
                                :
                                <DarkModeOutlinedIcon />
                        }
                    </div>
                </div>
            </div>

            {menu &&
                <div className={'menu-container ' + (lightMode ? 'lightmode' : 'app')}>
                    <div className="menu-links">
                        <p onClick={() => goto(home)}>Home</p>
                        <p onClick={() => goto(about)}>About</p>
                        <p onClick={() => goto(skills)}>Skills</p>
                        <p onClick={() => goto(works)}>Works</p>
                        <p onClick={() => goto(contact)}>Contact</p>
                    </div>

                    <a href="mailto:ogogorchimadika6@gmail.com" onClick={() => setMenu(false)}>
                        <div className="mobile-btn">
                            HIRE US
                        </div>
                    </a>
                </div>
            }

            <div className="desktop-navbar">
                <div className={"desktop-logo " + (lightMode ? 'logo-dark' : '')}>
                    <img src={logo} alt="" />
                    <p>BLUEJAG</p>
                </div>

                <div className="desktop-links">
                    <div className="d-links-container">
                        <p onClick={() => scroll(home)}>Home</p>
                        <p onClick={() => scroll(about)}>About</p>
                        <p onClick={() => scroll(skills)}>Skills</p>
                        <p onClick={() => scroll(works)}>Works</p>
                        <p onClick={() => scroll(contact)}>Contact</p>
                    </div>

                    <a href="mailto:ogogorchimadika6@gmail.com" onClick={() => setMenu(false)}>
                        <div className="hire-btn">
                            HIRE US
                        </div>
                    </a>

                    <div className={"dark-mode " + (lightMode ? 'logo-dark' : '')} onClick={toggleMode}>
                        {
                            !lightMode ?
                                <WbSunnyOutlinedIcon style={{ cursor: "pointer" }} />
                                :
                                <DarkModeOutlinedIcon style={{ cursor: "pointer" }} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar
